import { ThreadFirstPost } from './ThreadFirstPost';
import { Post, DummyPlainObject } from './Post';
import { PostList } from './PostList';

export class TaskContent extends Post {
  private threadList: PostList<ThreadFirstPost> = new PostList();

  public constructor(private _number: number, private threadFirstPost: ThreadFirstPost) { 
    super();
  }
  
  public get number(): number {
  return this._number;
  }

  public get title(): string {
    return this.threadFirstPost.title;
  }

  public get shortTitle(): string {
    return this.threadFirstPost.shortTitle;
  }

  public get id(): string {
    return this.threadFirstPost.id;
  }

  public get content(): string {
    return this.threadFirstPost.content;
  }

  public get username(): string {
    return this.threadFirstPost.username;
  }
  public get timestamp(): Date {
    return this.threadFirstPost.timestamp;
  }
  public get responseCount(): number {
    return this.threadList.count();
  }
  public get ymd(): string {
    return this.threadFirstPost.ymd;
  }
  public get hi(): string {
    return this.threadFirstPost.hi;
  }
  public get lastUpdate(): Date {
    return this.postList.lastUpdate();
  }
  public hasChildren(): boolean {
    return true;
  }
  public get postList(): PostList<Post> {
    return this.threadList; 
  }

  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {
      id: this.id,
      title: this.title,
      contents: this.content,
      username: this.username,
      timestamp: this.timestamp,
      number: this.number,
      list: this.threadList.toPlainObject()
    };

    return plainObject;
  }
}